// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface VeriffConfigOut {}

export const VeriffConfigOutSerializer = {
  _fromJsonObject(_object: any): VeriffConfigOut {
    return {};
  },

  _toJsonObject(_self: VeriffConfigOut): any {
    return {};
  },
};
